import { render, staticRenderFns } from "./TextInputConfig.vue?vue&type=template&id=3d54f2d3&scoped=true"
import script from "./TextInputConfig.vue?vue&type=script&lang=js"
export * from "./TextInputConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d54f2d3",
  null
  
)

export default component.exports